import React from "react";
import { Component } from "react";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/styles";
import { Grid } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { Card } from "@material-ui/core";
import ContractView from "../ScreenComponents/ContractView";
const useStyles = (theme) => ({
  root: {
    position: "relative",
    height: "auto",
    padding: "2rem",
    flexgrow: 1,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  details: {
    Items: "center",
  },
  column: {
    flexBasis: "33%",
  },
  helper: {
    //: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
});

export class ContractSelect extends Component {
  state = {
    expanded: null,
    recommendedContracts: [],
    notRecommended: [],
  };

  handleChange = (panel) => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };
  continue = (e) => {
    e.preventDefault();
    this.props.nextStep();
  };

  back = (e) => {
    e.preventDefault();
    this.props.prevStep();
  };

  setChoice = (val, approach) => {
    this.setState({ bool: val.target.checked });
    this.props.currentContext.setContract(val.target.checked, approach);
  };

  render() {
    const { classes } = this.props;
    const infoDict = this.props.currentContext.contractInformation;
    const recommendedContracts =
      this.props.currentContext.getContractRecommendations();
    const notRecommendedContracts =
      this.props.currentContext.getContractsNotRecommended();
    return (
      <Grid
        container
        xs={12}
        direction="row"
        spacing={2}
        className={classes.root}
      >
        <Card>
          <Grid
            item
            container
            xs={12}
            style={{
              backgroundColor: "#77a258",
              padding: "15px",
              color: "white",
              alignItems: "center",
              justify: "center",
            }}
          >
            <Grid
              item
              container
              xs={12}
              style={{
                backgroundColor: "#77a258",
                padding: "15px",
                color: "white",
                alignItems: "center",
                justify: "center",
              }}
            >
              <Typography>
                Based on your previous choices, these contracts are the best fit
                for your current situation.
              </Typography>
            </Grid>
            <ContractView
              recommendedContracts={recommendedContracts}
              infoDict={infoDict}
              classes={classes}
              currentContext={this.props.currentContext}
              handler={this.setChoice}
            />
          </Grid>
        </Card>
        <Card style={{ marginTop: 50, marginBottom: 15 }}>
          <Grid
            item
            container
            xs={12}
            style={{
              backgroundColor: "#b29317",
              padding: "15px",
              color: "white",
            }}
          >
            <Grid
              item
              xs={12}
              style={{
                backgroundColor: "#b29317",
                padding: "15px",
                color: "white",
              }}
            >
              <Typography>
                Based on your previous choices, these contracts are likely not
                good choices for your current situation.
              </Typography>
            </Grid>
            <ContractView
              recommendedContracts={notRecommendedContracts}
              infoDict={infoDict}
              classes={classes}
              currentContext={this.props.currentContext}
              handler={this.setChoice}
            />
          </Grid>
        </Card>
        <Grid item container direction="row" spacing={1}>
          <Grid item xs={12}>
            <Button
              fullWidth
              color="secondary"
              variant="contained"
              onClick={this.back}
            >
              Back
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Button
              fullWidth
              color="primary"
              variant="contained"
              onClick={this.continue}
            >
              Continue
            </Button>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}
export default withStyles(useStyles, { withTheme: true })(ContractSelect);
